import { GitBranch, GitCommit } from "lucide-react";
import { shortSha } from "@/lib/format";

export function CommitRef({
  branch,
  sha,
  message,
}: {
  branch: string;
  sha: string;
  message?: string | null;
}) {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground min-w-0 sm:shrink-0">
        <GitBranch className="h-3.5 w-3.5 shrink-0" />
        <span className="font-mono min-w-0 truncate">{branch}</span>
      </span>
      <span className="text-subtle-foreground text-xs">·</span>
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground shrink-0">
        <GitCommit className="h-3.5 w-3.5" />
        <span className="font-mono">{shortSha(sha)}</span>
      </span>
      {message ? (
        <>
          <span className="text-subtle-foreground text-xs">·</span>
          <span className="text-sm text-foreground truncate-1 min-w-0">{message}</span>
        </>
      ) : null}
    </div>
  );
}
